import { createPathFromRoute } from 'assets/utils/dom/UrlParsing';
import executeServerApi from 'assets/utils/server/ServerApi';
import { getDefaultHeaders, HttpMethod } from 'config/Api.Config';

type Params = Api.Core.ContractConsent.ManualAcceptance.IParams;
type Request = Api.Core.ContractConsent.ManualAcceptance.IRequest;
type Response = Api.Core.ContractConsent.ManualAcceptance.IResponse;
type Headers = Api.Core.ContractConsent.ManualAcceptance.IHeaders;
const url = '/api/Sales/ContractConsent/Accept/:id';
export default async function contractConsentManualAcceptancedApi(
  params: Params,
  body: Request
): Promise<Api.Res<Response>> {
  return await executeServerApi<Request, Response, Headers>({
    method: HttpMethod.post,
    url: createPathFromRoute(url, params),
    body,
    headers: getDefaultHeaders(),
  });
}
